// @ts-nocheck
import { css } from "styled-components";

export const carouselDotWrapperStyles = () => {
    return css`
        display: flex;
        justify-content: center;
        width: 100%;
    `;
};
